const getLocationsDropdown = document.querySelector(".js-header-menu");
const locationItemNav = document.querySelector('.navmenu-id-locations')

locationItemNav.addEventListener("mouseover", () => {
  getLocationsDropdown.classList.add("show-locations");
}, true);

getLocationsDropdown.addEventListener("mouseout", (e) => {
  getLocationsDropdown.classList.remove("show-locations");
}, true);

locationItemNav.addEventListener("mouseout", (e) => {
  getLocationsDropdown.classList.remove("show-locations");
}, true);
locationItemNav.addEventListener("focusin", () => {
  getLocationsDropdown.classList.add("show-locations");
});

locationItemNav.addEventListener("focusout", (e) => {
  setTimeout(() => {
    if (!locationItemNav.contains(document.activeElement)) {
      getLocationsDropdown.classList.remove("show-locations");
    }
  }, 50);
});